export class WindowLocation {
    public static assign(url: string) {
        const resolved = new URL(url, window.location.href);
        if (resolved.protocol === 'javascript:' || resolved.protocol === 'data:' || resolved.protocol === 'vbscript:') return;
        window.location.assign(url);
    }

    public static reload() {
        window.location.reload();
    }

    public static getHref() {
        return window.location.href;
    }

    public static setHref(href: string) {
        window.location.href = href;
    }

    public static getOrigin() {
        return window.location.origin;
    }

    public static getSearch() {
        return window.location.search;
    }

    public static getHash() {
        return window.location.hash;
    }
}
